import TimelineFullImage from '../../../../timeline/TimelineFullImage/TimelineFullImage';

const ImageLeft = require('../../../../../assets/img/timeline/modal/1996-race-1.jpg');
const ImageRight = require('../../../../../assets/img/timeline/modal/1996-race-2.jpg');

const RaceContent = () => {
    return (
        <>
            <div className="row">
                <div className="col-6">
                    <TimelineFullImage image={ImageLeft} />
                </div>
                <div className="col-6">
                    <TimelineFullImage image={ImageRight} />
                </div>
            </div>
            <h4>
                Race for Research
            </h4>
            <p>
                The inaugural Avon Race for Research fun run is held in Newcastle, NSW. Held for 16 years, this event attracted over 3,000 runners and walkers each year and raised $675,000 in total.
            </p>
        </>
    );
}

export default RaceContent;